const privacyPolicyAf = {
  breadcrumbs: { home: 'کور', title: 'د محرمیت تګلاره' },
  hero: {
    title: 'د محرمیت تګلاره',
    subtitle: 'ستاسو د شخصي ډاټا او محرمیت ساتل زموږ لومړیتوب دی'
  },
  principles: [
    { title: 'ډاټا ساتنه', description: 'موږ ستاسو شخصي معلومات د لوړې کچې ساتنې سره ساتو' },
    { title: 'روښانه', description: 'موږ په روښانه توګه بیان کوو چې موږ څه راټولوو او ولې' },
    { title: 'د کارن کنټرول', description: 'تاسو په خپلو معلوماتو باندې بشپړ کنټرول لرئ' },
    { title: 'د محرمیت ساتنه', description: 'موږ د ستاسو د اجازې پرته نه شریکوو' }
  ],
  dataTypes: [
    { category: 'شخصي معلومات', items: ['نوم', 'د تلیفون شمیره', 'د بریښنالیک پته', 'د زیږون نیټه'], purpose: 'ستاسو حساب جوړول او سمبالول' },
    { category: 'د پتې معلومات', items: ['د کور پته', 'د رسولو پته', 'وړاندیز', 'ولایت'], purpose: 'رسول او محلي خدمتونه' },
    { category: 'د تادیه کولو معلومات', items: ['د موبایل بانک شمیره', 'د بانک حساب', 'د معاملې تاریخچه'], purpose: 'د تادیه کولو په امن پروسه' },
    { category: 'د کارونې معلومات', items: ['د اپلیکیشن کارونې تاریخچه', 'لټونونه', 'د خوښې لیست'], purpose: 'شخصي تجربه چمتو کول' }
  ],
  usage: {
    title: 'موږ څنګه معلومات کاروو',
    primaryTitle: 'لومړني کارونه',
    primary: ['حساب جوړول او سمبالول', 'امرونه او رسول پروسس کول', 'د پیرودونکو ملاتړ چمتو کول', 'تادیه کول پروسس کول'],
    improveTitle: 'د ښه کیدو کارونه',
    improve: ['شخصي وړاندیزونه', 'د خدمت کیفیت ښه کول', 'ساتنه او د فریب مخنیوی', 'د بازار څېړنه او تحلیل']
  },
  rights: {
    title: 'ستاسو حقونه',
    items: [
      { right: 'د لاسرسي حق', description: 'پوه شئ چې موږ ستاسو په اړه څه معلومات ساتو' },
      { right: 'د سم کیدو حق', description: 'غلط یا زوړ معلومات سم کړئ' },
      { right: 'د ړنګولو حق', description: 'د خپلو شخصي معلوماتو د ړنګولو غوښتنه وکړئ' },
      { right: 'د ډاټا د لېږد حق', description: 'د خپلو معلوماتو یو کاپي ډاونلوډ کړئ' }
    ]
  },
  security: {
    title: 'د ساتنې تدابیر',
    intro: 'موږ د ستاسو معلوماتو د ساتلو لپاره لاندې تدابیرونه پلي کوو:',
    measures: ['SSL انکرپشن', 'منظم امنیتي معاینه', 'دوه فکتور تصدیق', 'ډاټا بیک اپ او بیا رغونه', 'د لاسرسي کنټرول سیسټمونه', 'منظم سیسټم تازه کول']
  },
  cookies: {
    title: 'د کوکی تګلاره',
    usageTitle: 'د کوکی کارونه',
    p1: 'موږ ستاسو د براوزر تجربه ښه کولو او زموږ خدمتونه شخصي کولو لپاره کوکی کاروو. کوکی ستاسو په وسیله کې خوندي شوي کوچني متن فایلونه دي.',
    p2: 'تاسو کولی شئ په خپل براوزر ترتیباتو کې کوکی کنټرول کړئ. د کوکی غیرفعالول ممکن د ځینو خدمتونو په سم کار کولو کې ستونزه رامنځته کړي.'
  },
  sharing: {
    title: 'د دریمې ډلې سره شریکول',
    intro: 'موږ ممکن په لاندې مواردو کې د دریمې ډلې سره معلومات شریک کړو:',
    authorizedTitle: 'اجازه شوی شریکول',
    notDoTitle: 'موږ څه نه کوو',
    authorized: ['د رسولو شرکاء (د پتې لپاره)', 'د تادیه کولو دروازې (د معاملو لپاره)', 'قانوني اړتیاوې (د محکمې حکم له مخې)'],
    notDo: ['اډورټایزرانو ته پلورل', 'د اجازې پرته د بازارموندنې لپاره کارول', 'د غیرضروري دریمې ډلې سره شریکول']
  },
  retention: {
    title: 'د ډاټا ساتنې تګلاره',
    retentionTitle: 'د ساتنې موده',
    retentionText: 'موږ ستاسو شخصي معلومات تر هغه وخته ساتو چې ستاسو حساب فعال وي یا د خدمتونو د چمتو کولو لپاره اړین وي.',
    deleteTitle: 'ړنګول',
    deleteText: 'د حساب د تړلو وروسته، موږ ستاسو شخصي معلومات په 30 ورځو کې ړنګوو، پرته له دې چې قانوني اړتیا بل څه وښيي.'
  },
  updates: {
    title: 'د تګلارې تازه کول',
    alert: 'دا د محرمیت تګلاره ممکن له وخت څخه وخت تازه شي',
    notify: 'موږ به د بدلونونو په اړه له بریښنالیک یا اپلیکیشن خبرتیاوو له لارې تاسو ته خبر ورکړو. د مهمو بدلونونو لپاره، موږ به ستاسو رضایت ترلاسه کړو.',
    lastUpdatedPrefix: 'وروستی تازه:',
    lastUpdatedDate: 'دسمبر 2023'
  },
  contact: {
    title: 'د محرمیت اړیکه',
    subtitle: 'که تاسو د دې تګلارې یا ستاسو د شخصي ډاټا په اړه کومه پوښتنه ولرئ، موږ سره اړیکه ونیسئ',
    button: 'موږ سره اړیکه ونیسئ',
    email: 'privacy@grameenbazar.com'
  }
};

export default privacyPolicyAf;
